<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4"  v-if="currentNatural">
          <div class="card-header pt-1 pb-0">
            <div>
              <h3 class="card-title text-primary mb-0">Espacio natural "{{ currentNatural.name }}"</h3>
              <div class="sub-line"></div>
              <div class="row col-12 mt-3">
                <router-link :to="{ name: 'Natural' }"
                             class="col-md-2 col-6 col-md-offset-10 btn btn-primary btn-sm text-white bg-blue-600 rounded-lg hover:bg-blue-900 mb-0  ml-auto">
                  Ir al listado
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body">
             <div class="row">
               <div class="col-md-6">
                 <div class="card">
                    <div class="card-body">
                      <label for="department_name" class="form-control-label">
                        Nombre
                      </label>
                      <p>{{ currentNatural.name }}</p>
                      <label for="department_name" class="form-control-label">
                        Provincia
                      </label>
                      <p>{{ currentNatural.province.name }}</p>
                      <label for="department_name" class="form-control-label">
                        Imagen
                      </label>
                      <div class="col-12">
                      <img class="img-thumbnail" width="200" :src="currentNatural.image.imageUrl">
                      </div>
                      <div class="col-12">
                      <label for="office_enabled" class="form-control-label">
                        Video
                      </label>
                      <div class="col-12" v-if="currentNatural.videoUrl">
                        <video :src="currentNatural.videoUrl">Si</video>
                      </div>
                      </div>
                    </div>
                 </div>

               </div>
             </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
//import { ref } from "vue";
import { useStore } from "vuex";
import {computed, onMounted} from "vue";
import { useRoute } from "vue-router";


    const route = useRoute();
    const store = useStore();

    const getCurrentNatural = async (id) => {
      return await store.dispatch("natural/getNaturalById", id);
    };

    const currentNatural = computed(() => store.state.natural.currentNatural);

    onMounted(() => {
      getCurrentNatural(route.params.id)
    });



</script>
